import React, { useState, useEffect } from 'react';

const SLOTS = [
  { tab: 'client', label: '企業・事業主の方', color: 'blue', buttons: [
    { text: '企業向け資料をダウンロード', page: '/service', className: 'bg-pink-beige text-white px-8 py-3 rounded-2xl text-sm font-semibold hover:bg-brown transition-all duration-300 transform hover:scale-105 shadow-lg' },
    { text: '企業向け資料をダウンロード', page: '/service 最下部', className: 'bg-brown text-white px-8 py-3 rounded-2xl text-sm font-semibold hover:bg-brown/90 transition-all duration-300 transform hover:scale-105 shadow-xl' },
    { text: '企業向け資料をダウンロード', page: '/download', className: 'bg-pink-beige text-white px-8 py-3 rounded-2xl text-sm font-semibold hover:bg-brown transition-all duration-300 transform hover:scale-105 shadow-lg' },
  ]},
  { tab: 'sr', label: '社労士の方', color: 'purple', buttons: [
    { text: '社労士向け資料をダウンロード', page: '/service', className: 'bg-white text-brown px-8 py-3 rounded-2xl text-sm font-semibold hover:bg-gray-50 transition-all duration-300 transform hover:scale-105 shadow-xl border-2 border-brown' },
    { text: '社労士向け資料をダウンロード', page: '/download', className: 'bg-pink-beige text-white px-8 py-3 rounded-2xl text-sm font-semibold hover:bg-brown transition-all duration-300 transform hover:scale-105 shadow-lg' },
  ]},
];

const DownloadAdmin = () => {
  const [data, setData] = useState([]);
  const [files, setFiles] = useState([]);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [openPicker, setOpenPicker] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    fetch('/data/downloads.json?t=' + Date.now())
      .then((r) => r.ok ? r.json() : [])
      .then(setData)
      .catch(() => setData([]));
    fetch('/api/admin-files.php?action=list')
      .then((r) => r.ok ? r.json() : { files: [] })
      .then((d) => setFiles(d.files || []))
      .catch(() => setFiles([]));
  }, []);

  const getUrl = (tab) => {
    const item = data.find((d) => d.tab === tab);
    return item?.fileUrl || '';
  };

  const setUrl = (tab, fileUrl) => {
    const exists = data.find((d) => d.tab === tab);
    if (exists) {
      setData(data.map((d) => d.tab === tab ? { ...d, fileUrl } : d));
    } else {
      setData([...data, { tab, fileUrl }]);
    }
    setOpenPicker(null);
  };

  const save = async () => {
    setSaving(true);
    setMessage('');
    try {
      const res = await fetch('/api/admin-data.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ file: 'downloads', data }),
      });
      const result = await res.json();
      setMessage(result.success ? '保存しました' : '保存に失敗しました');
    } catch {
      setMessage('保存に失敗しました');
    } finally {
      setSaving(false);
    }
  };

  const formatSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">ダウンロード資料 管理</h2>

      {message && <div className="mb-4 px-4 py-2 bg-green-100 text-green-800 rounded-lg text-sm">{message}</div>}

      <div className="space-y-4">
        {SLOTS.map((slot) => {
          const url = getUrl(slot.tab);
          const selectedFile = files.find((f) => f.url === url);
          const isOpen = openPicker === slot.tab;

          return (
            <div key={slot.tab} className={`bg-white rounded-xl shadow p-6 border-l-4 border-${slot.color}-500`}>
              <h3 className={`font-bold text-lg text-${slot.color}-700 mb-3`}>{slot.label}</h3>

              {url ? (
                <div className="bg-gray-50 rounded-lg p-3 space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gray-200 rounded border flex items-center justify-center shrink-0">
                      <span className="text-[10px] font-bold text-gray-500">{url.split('.').pop().toUpperCase()}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-bold truncate">{url.split('/').pop()}</p>
                      {selectedFile && <p className="text-xs text-gray-400">{formatSize(selectedFile.size)}</p>}
                    </div>
                    <button onClick={() => setPreviewUrl(url)}
                      className="bg-white text-gray-700 px-3 py-1.5 rounded-lg text-sm font-bold hover:bg-gray-100 border border-gray-300 shrink-0">
                      プレビュー
                    </button>
                    <button onClick={() => setOpenPicker(isOpen ? null : slot.tab)}
                      className="bg-gray-200 text-gray-700 px-3 py-1.5 rounded-lg text-sm font-bold hover:bg-gray-300 shrink-0">
                      変更
                    </button>
                  </div>
                  <div className="border-t border-gray-200 pt-3">
                    <p className="text-xs font-bold text-gray-500 mb-2">本番ボタン（クリックでDLテスト）:</p>
                    <div className="flex flex-wrap gap-3 items-center">
                      {slot.buttons.map((btn, i) => (
                        <div key={i} className="flex flex-col items-center gap-1">
                          <a href={url} download className={btn.className}>
                            {btn.text}
                          </a>
                          <span className="text-[10px] text-gray-400">{btn.page}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <button onClick={() => setOpenPicker(isOpen ? null : slot.tab)}
                  className="w-full border-2 border-dashed border-gray-300 rounded-lg p-4 text-sm text-gray-400 hover:border-gray-400 hover:text-gray-500 transition-colors">
                  ファイルを選択してください
                </button>
              )}

              {isOpen && (
                <div className="mt-3 border border-gray-200 rounded-lg max-h-64 overflow-y-auto">
                  {files.length === 0 ? (
                    <p className="px-3 py-4 text-sm text-gray-400 text-center">アップロード済みファイルがありません</p>
                  ) : (
                    files.map((file, idx) => {
                      const isImg = /\.(jpg|jpeg|png|gif|svg|webp)$/i.test(file.name);
                      const ext = file.name.split('.').pop().toUpperCase();
                      const selected = url === file.url;
                      return (
                        <button key={idx} type="button"
                          onClick={() => setUrl(slot.tab, file.url)}
                          className={`w-full text-left px-3 py-2 hover:bg-blue-50 flex items-center gap-3 border-b last:border-b-0 ${selected ? 'bg-blue-50' : ''}`}>
                          {isImg ? (
                            <img src={file.url} alt={file.name} className="w-10 h-10 object-cover rounded border shrink-0" />
                          ) : (
                            <div className="w-10 h-10 bg-gray-100 rounded border flex items-center justify-center shrink-0">
                              <span className="text-[10px] font-bold text-gray-500">{ext}</span>
                            </div>
                          )}
                          <div className="flex-1 min-w-0">
                            <span className={`block text-sm truncate ${selected ? 'font-bold text-blue-700' : 'text-gray-700'}`}>{file.name}</span>
                            <span className="block text-xs text-gray-400">{formatSize(file.size)}</span>
                          </div>
                          {selected && <span className="text-blue-600 text-xs font-bold shrink-0">選択中</span>}
                        </button>
                      );
                    })
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-6">
        <button onClick={save} disabled={saving}
          className="bg-blue-600 text-white px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-blue-700 disabled:opacity-50">
          {saving ? '保存中...' : '保存'}
        </button>
      </div>

      {previewUrl && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={() => setPreviewUrl(null)}>
          <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <span className="text-sm font-bold truncate">{previewUrl.split('/').pop()}</span>
              <button onClick={() => setPreviewUrl(null)} className="text-gray-400 hover:text-gray-600 text-xl leading-none">&times;</button>
            </div>
            <div className="flex-1 overflow-auto p-4 flex items-center justify-center">
              {/\.(pdf)$/i.test(previewUrl) ? (
                <iframe src={previewUrl} title="プレビュー" className="w-full h-[70vh] rounded border" />
              ) : /\.(jpg|jpeg|png|gif|svg|webp)$/i.test(previewUrl) ? (
                <img src={previewUrl} alt="プレビュー" className="max-w-full max-h-[70vh] object-contain" />
              ) : (
                <p className="text-gray-500">このファイル形式はプレビューできません。</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadAdmin;
